module.exports = __webpack_public_path__ + "img/bg-competition.1b50d0bc.png";